import { styled } from '@payright/web-components';
import { PropsWithChildren } from 'react';

const SCSectionHeader = styled.h4`
  font-weight: 700;
  font-size: 1.13rem;
  vertical-align: baseline;
  color: ${(props) => props.theme.colours.blue.base};
`;

export const SectionHeader = ({ children }: PropsWithChildren) => (
  <SCSectionHeader>{children}</SCSectionHeader>
);
